import { render } from "./SuggestionDetails.vue?vue&type=template&id=38c323c6"
import script from "./SuggestionDetails.vue?vue&type=script&lang=js"
export * from "./SuggestionDetails.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__